module.exports = __webpack_public_path__ + "static/media/MrYinShi.77e7e14a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub1/MrYinShi.jpg
// module id = 202
// module chunks = 0